<template>
  <v-layout row wrap>
    <v-flex xs12 md8 v-if="!getProfileHaveClient">
      <v-card>
        <v-card-title>
          <span class="headline">Служба контрагентов. </span>
        </v-card-title>
        <v-card-text>
          Служба контрагентов позволяет быстро находить избранных контрагентов, ставить их на мониторинг в егрюл, позволяет группировать контрагентов по спискам, а также вести протокол просмотра контрагентов.
          Для работы с избранными контрагентами, необходимо определить Юридическое лицо которое Вы представляете.
          Регистрируйтесь и общайтесь от имени Вашей компании.
        </v-card-text>
        <v-card-actions>
          <v-btn to="/register">Регистрация</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs12 md8 v-if="getProfileHaveClient && !$route.params.cagentId">
      <v-favorite-company-set :tagIds="tagIds"></v-favorite-company-set>
    </v-flex>
    <v-flex xs12 md8 v-if="getProfileHaveClient && $route.params.cagentId">
      <v-c-agent-page :itemId="$route.params.cagentId"></v-c-agent-page>
    </v-flex>

  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'
  import vFavoriteCompanySet from './FavoriteCompanySet.vue'
  import vCAgentPage from './CAgentPage.vue'

  export default {
    name: 'favorite-company-panel',
    components: {vFavoriteCompanySet, vCAgentPage},
    props: {
    },
    data: () => ({
      tagIds: []
    }),
    mounted () {
      this.setTagIds()
    },
    watch: {
    // в случае изменения маршрута запрашиваем данные вновь
      '$route' () {
        this.setTagIds()
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient'
      })
    },
    methods: {
      setTagIds () {
        this.tagIds = [].concat(this.$route.query && this.$route.query.tag ? this.$route.query.tag : [])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FavoriteCompanyPanel.vue?113e3c42